export enum TemplateConsentRequiredOption {
    REQUIRED = 'Required',
    NOT_REQUIRED = 'Not Required'
}